import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import PropTypes from 'prop-types';
import Button from '@components/smartAdminUI/Button';
import GAEventTracking from '@components/tracking/GAEventTracking';

import {
  startImpersonation,
  stopImpersonation,
} from '@redux/modules/impersonation';
import {
  selectStatus,
} from '@redux/selectors/ImpersonationSelector';

const TeamMemberRowActionButtons = ({
  showDeleteButton = true,
  onDeleteRow,
  showStartImpersonationButton = false,
  currRow,
}) => {
  const dispatch = useDispatch();
  const status = useSelector(selectStatus);
  const isImposter = target => status?.ImposterName?.toUpperCase() === target.memberMlsId.toUpperCase();

  const gaEventTracker = GAEventTracking('Impersonate');

  const handleDelete = () => onDeleteRow(currRow);
  const handleStartImpersonation = () => {
    dispatch(startImpersonation({ memberMlsId: currRow.TeamLeadMlsId }));
    gaEventTracker('Start Impersonate', `${currRow.TeamMemberFullName} Impersonating ${currRow.TeamLeadFullName} (${currRow.TeamLeadMlsId})`);
  };
  const handleStopImpersonation = () => {
    dispatch(stopImpersonation());
  };

  return (
    <>
      {showDeleteButton && (
        <Button
          onClick={handleDelete}
          variant="primary btn-sm"
          tooltipText="Remove Member"
        >
          <i className="far fa-trash-alt" />
        </Button>
      )}
      {showStartImpersonationButton && !isImposter({ memberMlsId: currRow.TeamLeadMlsId }) && (
        <Button
          onClick={handleStartImpersonation}
          variant="primary btn-sm"
          tooltipText="Start Impersonating"
        >
          <i className="fas fa-play" />
        </Button>
      )}
      {isImposter({ memberMlsId: currRow.TeamLeadMlsId }) && (
        <Button
          onClick={handleStopImpersonation}
          variant="primary btn-sm"
          tooltipText="Stop Impersonating"
        >
          <i className="fas fa-stop" />
        </Button>
      )}
    </>
  );
};

TeamMemberRowActionButtons.propTypes = {
  showDeleteButton: PropTypes.bool,
  onDeleteRow: PropTypes.func,
  showStartImpersonationButton: PropTypes.bool,
  currRow: PropTypes.shape({
    UniqueID: PropTypes.number,
    TeamLeadMlsId: PropTypes.string,
    TeamLeadFullName: PropTypes.string,
    TeamMemberFullName: PropTypes.string,
  }),
};

export default TeamMemberRowActionButtons;
